import React, { useEffect, useState, useRef } from 'react';
import Spacing from '../Spacing';
import AnimatedSection from '../AnimatedSection';
import { useInView } from 'framer-motion';

function CountingNumber({ endValue, duration = 2.5, decimals = 0, suffix = "" }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  useEffect(() => {
    if (!isInView) return;
    let startTimestamp = null;
    let animationFrameId;

    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / (duration * 1000), 1);
      
      // easeOutQuart
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      setCount(easeOutQuart * endValue);
      
      if (progress < 1) {
        animationFrameId = window.requestAnimationFrame(step);
      } else {
        setCount(endValue); // Ensure exact final value
      }
    };
    
    animationFrameId = window.requestAnimationFrame(step);
    return () => window.cancelAnimationFrame(animationFrameId);
  }, [endValue, duration, isInView]);

  return (
    <span ref={ref}>
      {count.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}{suffix}
    </span>
  );
}

export default function Statistics() {
  const stats = [
    { number: <CountingNumber endValue={10000} suffix="+" />, label: 'Happy Customers' },
    { number: "Premium", label: 'Ayurvedic Formulation' },
    { number: <CountingNumber endValue={4.8} decimals={1} suffix="/5" />, label: 'Average Rating' },
    { number: <CountingNumber endValue={98} suffix="%" />, label: 'Positive Feedback' }
  ];

  return (
    <section className="cs_accent_bg" style={{ position: 'relative', overflow: 'hidden' }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'linear-gradient(90deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0) 100%)',
        zIndex: 1
      }}></div>
      <Spacing lg="80" md="50" />
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="row cs_gap_y_40 cs_gap_y_md_30">
          {stats.map((stat, index) => (
            <div className="col-lg-3 col-6" key={index}>
              <AnimatedSection animation="scaleUp" delay={index * 0.1}>
                <div className="text-center p-2 p-md-0">
                  <h2 className="cs_bold cs_white_color mb-1 mb-md-2" style={{ fontSize: 'clamp(28px, 5vw, 60px)', textShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
                    {stat.number}
                  </h2>
                  <p className="cs_white_color mb-0 fw-medium" style={{ fontSize: 'clamp(14px, 2vw, 18px)', opacity: 0.9 }}>
                    {stat.label}
                  </p>
                </div>
              </AnimatedSection>
            </div>
          ))}
        </div>
      </div>
      <Spacing lg="80" md="50" />
    </section>
  );
}
